<template>
  <div class="ts-overflow-y-auto ts-overflow-x-hidden" style="height: 16rem">
    <TsLoadingBanner :loading="branch_fetch">
      <div v-if="errors.has('branch_id_list')" class="ts-text-red-500">
        {{ errors.first('branch_id_list') }}
      </div>
      <div class="row" v-for="(branch, index) in branchNameList" :key="index">
        <div class="col-md-12" v-if="isCheckTriger">
          <ts-checkbox
            :checkedValue="hasValueCheck(branch.branch_id)"
            :value="branch.branch_id"
            @change="e => onBranchCheck(e, branch.branch_id)"
            >{{ branch.branch_name_en }}</ts-checkbox
          >
          <div class="ts-pl-6" v-if="hasValueCheck(branch.branch_id)">
            <a-select
              v-model="model.branch_id_list[branch.branch_id].ac_year_id"
              allowClear
              class="ts-w-full"
              :options="academicYearByBranch(branch.branch_id)"
              showSearch
              :maxTagCount="1"
              :maxTagTextLength="17"
              @change="onAcYearChange"
            >
            </a-select>
            <div
              v-if="errors.has(`branch_id_list.${branch.branch_id}.ac_year_id`)"
              class="ts-text-red-500"
            >
              {{
                errors.first(`branch_id_list.${branch.branch_id}.ac_year_id`)
              }}
            </div>
          </div>
        </div>
      </div>
    </TsLoadingBanner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'branchList',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      errors: new Errors(),
      branch_fetch: true,
      isCheckTriger: true,
      academicYears: []
    }
  },
  mounted() {
    this.model = this.value
    this.getBranch()
      .then(async () => {
        return this.fetchAcademicYear()
      })
      .then(() => this.autoSelectDefaultBranch())
      .finally(() => {
        this.branch_fetch = false
      })
  },
  computed: {
    ...mapState('feeSetup', ['branchList']),
    academicYearByBranch: vm => branchId => {
      return vm.academicYears
        .filter(ac => ac.branch_id === branchId)
        .map(el => ({
          value: el.ac_year_id,
          label: `${el.ac_year} - ${el.ac_status_description}`
        }))
    },
    hasValueCheck: vm => branchId => {
      return vm.model.branch_id_list[branchId] !== undefined
    },
    defaultBranchId() {
      return this.$store.state.authUser.default_branch_id
    },
    branchNameList() {
      return this.branchList.slice().sort((a, b) => {
        return a.branch_id === this.defaultBranchId
          ? -1
          : b.branch_id === this.defaultBranchId
          ? 1
          : 0
      })
    }
  },
  methods: {
    ...mapActions('feeSetup', ['getBranch']),
    async fetchAcademicYear(branchId = undefined) {
      this.branch_fetch = true
      let response = await this.$store.dispatch('feeSetup/getAcademicYear', {
        branch_id: branchId ? branchId : this.defaultBranchId
      })
      const newYears = response.academic_years

      // Create a map by ID to ensure uniqueness
      const combined = [...this.academicYears, ...newYears]
      const uniqueMap = new Map(combined.map(item => [item.ac_year_id, item]))
      this.academicYears = Array.from(uniqueMap.values())

      this.branch_fetch = false
      return response
    },
    autoSelectDefaultBranch() {
      this.model.branch_id_list = {
        [this.defaultBranchId]: {
          ac_year_id: undefined
        }
      }
    },
    async onBranchCheck(event, branchId) {
      const isExist = this.model.branch_id_list[branchId]
      this.isCheckTriger = false

      if (!event && isExist) {
        delete this.model.branch_id_list[branchId]
      }

      if (event && !isExist) {
        this.model.branch_id_list[branchId] = {
          ac_year_id: undefined
        }

        const checkAcYearExist = this.academicYears.filter(
          ac => ac.branch_id === branchId
        ).length
        if (!checkAcYearExist) {
          await this.fetchAcademicYear(branchId)
        }
      }

      this.$nextTick(() => (this.isCheckTriger = true))
    },
    onAcYearChange() {
      this.isCheckTriger = false
      this.$nextTick(() => (this.isCheckTriger = true))
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>
